import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const APEditSubCategory = () => {
  const navigate = useNavigate();
  const { slug1, slug2 } = useParams();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    name_en: '',
    name_ru: '',
    name_uk: '',
  });
  const [errors, setErrors] = useState({
    name_en: '',
    name_ru: '',
    name_uk: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;

    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + `/admin/subcategory/admin_edit/${slug1}`,
        null,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setUserData({
        name_en: '',
        name_ru: '',
        name_uk: '',
        ...response.data.response,
      });
    } catch (error) {
      setLoading(false);

      console.error('Error at edit Sub Category', error);
    }
  };

  const handleClick = async () => {
    try {
      const newErrors = {};

      if (userData.name_en === '') {
        newErrors.name_en = 'Sub Category Name (en) is required';
        window.scrollTo(0, 0);
      }
      if (userData.name_ru === '') {
        newErrors.name_ru = 'Sub Category Name (ru) is required';
        window.scrollTo(0, 0);
      }
      if (userData.name_uk === '') {
        newErrors.name_uk = 'Sub Category Name (uk) is required';
        window.scrollTo(0, 0);
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          icon: 'question',
          cancelButtonText: 'No',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          title: 'Update Sub Category?',
          text: 'Do you want to update the Sub Category?',
        });

        if (confirmationResult.isConfirmed) {
          setLoading(true);

          const response = await axios.post(
            BaseApi + `/admin/subcategory/admin_edit/${slug1}`,
            userData,
            {
              headers: {
                key: ApiKey,
                adminid: adminID,
                ContentType: 'application/json',
                Authorization: `Bearer ${tokenKey}`,
              },
            },
          );

          setLoading(false);

          if (response.data.status === 200) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Close',
              title: 'Sub Category updated successfully!',
            });

            navigate(`/admin/categories/subindex/${slug2}`);
          } else {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'Close',
              title: response.data.message,
            });
          }
        }
      }
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        confirmButtonText: 'Close',
        text: 'Could not update username. Please try again later!',
      });

      console.error('Could not change username!', error);
    }
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => navigate('/admin/admins/dashboard')}
                    >
                      Dashboard
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => navigate('/admin/categories')}
                    >
                      Categories
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => window.history.back()}
                    >
                      {userData?.cateogory_name}
                    </Link>
                    <Typography color='text.primary'>Edit Sub Category</Typography>
                  </Breadcrumbs>
                </div>
                <h2 className='adminPageHeading'>Edit Sub Category</h2>
                <form className='adminForm'>
                  <div className='mb-4 mt-5'>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Sub Category Name (uk) <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_uk'
                        name='name_uk'
                        value={userData.name_uk}
                        onChange={handleChange}
                        placeholder='Sub Category Name (uk)'
                        className={`form-control ${errors.name_uk && 'input-error'}`}
                      />
                      {
                        errors.name_uk && (
                          <div className='text-danger'>{errors.name_uk}</div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Sub Category Name (ru) <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_ru'
                        name='name_ru'
                        value={userData.name_ru}
                        onChange={handleChange}
                        placeholder='Sub Category Name (ru)'
                        className={`form-control ${errors.name_ru && 'input-error'}`}
                      />
                      {
                        errors.name_ru && (
                          <div className='text-danger'>{errors.name_ru}</div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Sub Category Name (en) <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_en'
                        name='name_en'
                        value={userData.name_en}
                        onChange={handleChange}
                        placeholder='Sub Category Name (en)'
                        className={`form-control ${errors.name_en && 'input-error'}`}
                      />
                      {
                        errors.name_en && (
                          <div className='text-danger'>{errors.name_en}</div>
                        )
                      }
                    </div>
                    <div className='adminBottomButtons'>
                      <button
                        type='button'
                        onClick={handleClick}
                        className='btn btn-primary button1'
                      >
                        SAVE
                      </button>
                      <button
                        type='button'
                        onClick={() => getData()}
                        className='btn btn-primary button2'
                      >
                        RESET
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )
        }
      </div>
    </>
  );
};

export default APEditSubCategory;
